import { RouteRecordRaw } from "vue-router";

const sidebarName = "SidebarSace";

export const saceRoutes: RouteRecordRaw[] = [
  {
    path: "/sace",
    component: () => import("@/views/common/Home.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/sace/saceMap",
    component: () => import("@/views/sace/SaceMap.view.vue"),
    meta: {
      layout: "LayoutDefautl",
      sidebar: sidebarName,
    },
  },
];
